import React, { ComponentProps } from 'react'
import { Button as CommonButton } from 'src/shared/components/button/button'
import type {
  WebsiteButtonsInterface,
  WebsiteThemeInterface,
  WebsiteTypographySettingsStylesInterface,
} from 'src/shared/types/website-settings-types'
export interface PublicPageButtonProps
  extends Omit<ComponentProps<typeof CommonButton>, 'attrId'> {
  button?: Partial<WebsiteButtonsInterface>
  theme?: WebsiteThemeInterface
  attrId?: string
  paragraph?: WebsiteTypographySettingsStylesInterface
}

export const PublicPageButton: React.FC<PublicPageButtonProps> = ({
  button,
  theme,
  text,
  loading = false,
  onClick,
  attrId = '',
  width,
  paragraph,
}) => {
  const hover = {
    backgroundColor: theme?.buttons.primaryHoveredButtonBackgroundColor,
  }

  const active = {
    backgroundColor: theme?.buttons.primaryPressedButtonBackgroundColor,
  }
  const typography = button?.typography ?? paragraph
  return (
    <CommonButton
      attrId={attrId}
      text={text}
      loading={loading}
      onClick={onClick}
      textColor={theme?.buttons.primaryButtonTextColor}
      background={theme?.buttons.primaryButtonBackgroundColor}
      hover={hover}
      mobileHover={hover}
      border={{
        ...button?.border,
        color: theme?.buttons.primaryButtonBorderColor,
      }}
      padding={button?.padding}
      textFontFamily={typography?.fontFamily}
      textFontSize={typography?.fontSize}
      textFontStyle={typography?.fontStyle}
      textFontWeight={typography?.fontWeight}
      mobileTextFontFamily={typography?.mobileFontFamily}
      mobileTextFontSize={typography?.mobileFontSize}
      mobileTextFontStyle={typography?.mobileFontStyle}
      mobileTextFontWeight={typography?.mobileFontWeight}
      width={width}
      active={active}
    />
  )
}
